export default "__VITE_ASSET__CfWFVz5O__"